import ymaps from 'ymaps';
import MobileDetect from './mobile';
import 'jquery.appear';
import $ from "jquery";

class Map {

	Init = () => {
		const self = this;
		self.InitMap();

	};
	InitMap = () => {

		let lang = 'ru_RU';
		if($('.map').attr('data-lang')==='en'){
			lang = 'en_RU'
		}

		ymaps.load('https://api-maps.yandex.ru/2.1/?lang='+lang+'&amp;').then(ymaps => {

			const coords = $('#map').attr('data-coords');
			let coords_arr;
			if(coords){
				coords_arr = coords.split(',');
			}

			const MyMap = new ymaps.Map('map', {
				//center: [55.66862306030893, 37.46230610707087],
				center: [coords_arr[0],coords_arr[1]],
				zoom: 15,
				controls: []
			});

			const zoomControl = new ymaps.control.ZoomControl({
				options: {
					size: "small",
					position: {
						top: '85vh',
						bottom: 'auto',
						left: 20
					}
				}
			});
			if($(window).width()>1000){
				MyMap.controls.add(zoomControl);
			}

			MyMap.behaviors.disable('scrollZoom');
			if ('ontouchstart' in window || navigator.maxTouchPoints) {
				MyMap.behaviors.disable('drag');
			}


			const myPlacemark = new ymaps.Placemark(MyMap.getCenter(), {
			}, {
				balloonShadow: false,
				balloonPanelMaxMapArea: 0,
				iconLayout: 'default#image',
				iconImageHref: '/src/img/location/marker.svg',
				iconImageSize: [73, 83],
				iconImageOffset: [-36, -41],
			});

			MyMap.geoObjects.add(myPlacemark);


			let top = 300, left = 100;
			//if($('#map').hasClass('map-moved') && !MobileDetect.Init()){
			//	top = 250;
			//}
			if($(window).width()<=1000){
				top = 0;
				left = 0;
			}
			let pixelCenter = MyMap.getGlobalPixelCenter(MyMap.getCenter());
			pixelCenter[1] = pixelCenter[1]+top;
			pixelCenter[0] = pixelCenter[0]+left;
			let geoCenter = MyMap.options.get('projection').fromGlobalPixels(pixelCenter, MyMap.getZoom());

			MyMap.setCenter(geoCenter);

			$(window).on('resize', function(){
				MyMap.container.fitToViewport();
			});


		}).catch(error => console.log('Failed to load Yandex Maps', error));

	};


}

export default new Map;